<template>
  <div class="top" v-bind:style= "{'background-image':'url(images/top/bg_top.jpg)' }">
    <div class="top__kv kv">
      <div class="kv__logo">
        <img src="images/top/header_logo.png" alt="Dr.Stone">
      </div>
      
      <div class="kv__ill">
        <img src="images/top/image_kv.png" alt="">
      </div>

      <div class="kv__top-stone">
        <img src="images/top/header_stone.png" alt="">
      </div>
      <div class="kv__top-right-stone">
        <img src="images/top/bg_parts-stone.png" alt="">
      </div>

      <div class="kv__title">
        <img src="images/top/text_kv.png" alt="">
      </div>
    </div>

    <div class="top__explain explain">

      <div class="explain__story">
        <img src="images/top/comic_01.png" alt="">
      </div>
      <div class="explain__story-text">
        <img src="images/top/text_01.png" alt="">
      </div>

      <div class="explain__story-btn-wrap">
        <button v-on:click="toStory1" class="c-btn--pixel u-pixel10">→ 0と1でイラストを描け!</button>
      </div>

      <div class="explain__free">
        <img src="images/top/comic_02.png" alt="">
      </div>
      <div class="explain__free-text">
        <img src="images/top/text_02.png" alt="">
      </div>

      <div class="explain__chara">
        <img src="images/top/image_chara.png" alt="">
      </div>

      <div class="explain__free-btn-wrap">
        <button v-on:click="toFreeDraw" class="c-btn--pixel u-pixel10">→ お絵描きツールを起動!</button>
      </div>
    </div>

    <div class="top__comics">
      <div class="top-comics--1">
        <img src="images/top/comic_03.png" alt="">
      </div>
      <div class="top-comics--2">
        <img src="images/top/comic_04.png" alt="">
      </div>
      <div class="top-comics--3">
        <img src="images/top/comic_05.png" alt="">
      </div>
    </div>

    <div class="top__banner banner">
      <div class="banner__info">
        <div class="banner__text">
          <img src="images/top/info_text.png" alt="">
        </div>
        <div class="banner__comic">
          <img src="images/top/info_comic.png" alt="">
        </div>
      </div>

      <div class="banner__btn">
        <a href="http://jumpbookstore.com/client_info/SHUEISHA/html/player/viewer.html?tw=2&lin=1&cid=SHSA_ST01C88287702401_57" target="_blank" class="c-btn--pixel u-pixel10">→ 最新巻を試し読み!</a>
      </div>
    </div>

    <footer class="c-footer">
      <div class="c-footer__img">
        <img src="images/top/copyright.png" alt="©米スタジオ・Boichi／集英社">
      </div>
    </footer>
  </div>
</template>

<script>

export default {
  components: {
  },
  data: function() {
    return {
      
    }
  },
  created() {
    
  },
  mounted() {

  },
  methods: {
    toStory1() {
      this.$emit("transition", "Story1")
    },
    toFreeDraw() {
      this.$emit("transition", "FreeDraw")
    },

  }
}

</script>

<style lang="scss">


.top {
  background-position-x: center;
  background-position-y: top;
  background-repeat: no-repeat;
  background-size: cover;
  height: auto;
  min-height: 100%;
  width: 100%;

  &-comics {
    position: relative;

    &--1 {
      filter: drop-shadow(4px 4px 5px rgba(0,0,0,0.6));
      position: relative;
      margin-left: get_percent(27px);
      margin-right: auto;
      width: get_percent(calc_retina3(679px));
      z-index: 10;
    }

    &--2 {
      filter: drop-shadow(4px 4px 5px rgba(0,0,0,0.6));
      position: relative;
      margin-left: auto;
      margin-right: get_percent(27px);
      margin-top: get_percent(-80px);
      width: get_percent(calc_retina3(685px));
      z-index: 9;
    }

    &--3 {
      filter: drop-shadow(4px 4px 5px rgba(0,0,0,0.6));
      margin-left: get_percent(27px);
      margin-right: auto;
      margin-top: get_percent(-50px);
      position: relative;
      width: get_percent(calc_retina3(884px));
      z-index: 8;
    }
  }
}

.kv {
  position: relative;

  &__logo {
    margin: 0 auto;
    padding-top: get_percent(calc_retina3(12px));
    position: relative;
    width: get_percent(calc_retina3(1029px));
    z-index: 5;
  }

  &__ill {
    margin-left: auto;
    margin-right: 0;
    margin-top: get_percent(-84px);
    width: get_percent(calc_retina3(1170px));
  }

  &__top-stone {
    left: 0;
    position: absolute;
    top: 0;
    width: get_percent(calc_retina3(1170px));
    z-index: 4;
  }

  &__top-right-stone {
    right: 0;
    margin-bottom: get_percent(20px);
    position: absolute;
    bottom: 0;
    width: get_percent(calc_retina3(312px));
    z-index: 4;
  }

  &__title {
    margin: get_percent(-52px) auto 0;
    position: relative;
    width: get_percent(calc_retina3(1062px));
    z-index: 5;
  }
}

.explain {
  padding-top: get_percent(26px);
  position: relative;

  &__story {
    margin: 0 auto get_percent(12px) get_percent(24px);
    width: get_percent(calc_retina3(915px));
  }

  &__story-text {
    margin: 0 auto get_percent(21px);
    width: get_percent(calc_retina3(812px));
  }

  &__story-btn-wrap {
    margin-bottom: get_percent(21px);
  }

  &__free {
    margin: 0 get_percent(27px) 0 auto;
    width: get_percent(calc_retina3(902px));
  }

  &__free-text {
    margin: 0 auto get_percent(21px);
    width: get_percent(calc_retina3(820px));
  }

  &__chara {
    bottom: 0;
    margin-bottom: get_percent(150px);
    position: absolute;
    right: 0;
    width: get_percent(calc_retina3(312px));
    z-index: 5;
  }

  &__free-btn-wrap {
    margin-bottom: get_percent(44px);
  }
}

.banner {

  &__info {
    pointer-events: none;
    align-items: baseline;
    column-gap: get_percent(10px);
    display: flex;
    justify-content: center;
    margin-bottom: get_percent(14px);
    margin-top: get_percent(-18px);
    position: relative;
    z-index: 10;
  }

  &__text {
    width: get_percent(calc_retina3(681px));

    img {
      padding-bottom: get_percent(10px, calc_retina3(681px));
    }
  }

  &__comic {
    width: get_percent(calc_retina3(332px));
  }

  &__btn {
    margin-bottom: get_percent(41px);
  }
}

</style>
